export const BRAND_NAME = '786Sky';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = '786sky.com';
export const PROVIDER_ID = 'BetFair';
